import { clamp } from './math.js';
const cache=new Map(); let parser;
const finite=value=>{if(!Number.isFinite(value))throw new TypeError('Color channels must be finite numbers.');return value;};
export function color(...args) {
  if(args.length>4)throw new TypeError('A color accepts at most four channels.');
  if(args.length>=3) return [clamp(finite(args[0])/255),clamp(finite(args[1])/255),clamp(finite(args[2])/255),clamp(finite(args[3]??255)/255)];
  const value=args[0];
  if(value?._array){const channels=Array.from(value._array);if(channels.length!==3&&channels.length!==4)throw new TypeError('Normalized colors require three or four channels.');if(channels.length===3)channels.push(1);return channels.map(value=>clamp(finite(value)));}
  if(Array.isArray(value)||ArrayBuffer.isView(value)){if(!Number.isInteger(value.length)||value.length<1||value.length>4)throw new TypeError('Colors require between one and four channels.');return color(...value);}
  if(typeof value==='number') return [clamp(finite(value)/255),clamp(value/255),clamp(value/255),clamp(finite(args[1]??255)/255)];
  if(value!==undefined&&value!==null&&typeof value!=='string')throw new TypeError('A color requires numeric channels, an array or a CSS color string.');
  const text=String(value??'#000000').trim().toLowerCase();
  if(cache.has(text)) return cache.get(text).slice();
  let result;
  const hex=text.match(/^#([\da-f]{3,8})$/i);
  if(hex && [3,4,6,8].includes(hex[1].length)) {
    let h=hex[1]; if(h.length<5)h=h.split('').map(x=>x+x).join('');
    result=[0,2,4].map(i=>parseInt(h.slice(i,i+2),16)/255); result.push(h.length===8?parseInt(h.slice(6,8),16)/255:1);
  } else {
    const rgb=text.match(/^rgba?\(([^)]+)\)$/);
    const number=/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?%?$/;
    let tokens;
    if(rgb){const body=rgb[1];if(body.includes(',')){if(!body.includes('/'))tokens=body.split(',').map(value=>value.trim());}else{const parts=body.split('/');if(parts.length<=2){tokens=parts[0].trim().split(/\s+/);if(parts.length===2)tokens.push(parts[1].trim());}}}
    if(tokens&&[3,4].includes(tokens.length)&&tokens.every(token=>number.test(token))) {
      const p=tokens;
      result=p.slice(0,3).map(x=>clamp(parseFloat(x)/(x.endsWith('%')?100:255)));
      result.push(p[3]===undefined?1:clamp(parseFloat(p[3])/(p[3].endsWith('%')?100:1)));
    } else {
      if(!parser) {
        const canvas=typeof OffscreenCanvas!=='undefined'?new OffscreenCanvas(1,1):typeof document!=='undefined'?document.createElement('canvas'):null;
        if(!canvas)throw new TypeError('Invalid or unsupported color: '+text);
        canvas.width=canvas.height=1;parser=canvas.getContext('2d',{willReadFrequently:true});
        if(!parser)throw new Error('CSS color parsing requires a Canvas2D context.');
      }
      // Invalid assignments leave fillStyle untouched. Two distinct sentinels
      // distinguish that no-op from valid colors that happen to equal either.
      parser.fillStyle='#010203';parser.fillStyle=text;const first=parser.fillStyle;
      parser.fillStyle='#040506';parser.fillStyle=text;
      if(first!==parser.fillStyle)throw new TypeError('Invalid color: '+text);
      parser.clearRect(0,0,1,1);parser.fillRect(0,0,1,1);
      result=Array.from(parser.getImageData(0,0,1,1).data,x=>x/255);
    }
  }
  if(result.length!==4 || result.some(x=>!Number.isFinite(x))) throw new TypeError('Invalid color: '+text);
  if(cache.size>=256)cache.delete(cache.keys().next().value);
  cache.set(text,result); return result.slice();
}
export const sameColor=(a,b)=>!!a&&!!b&&a.length===b.length&&a.every((v,i)=>v===b[i]);
